export const FakeAxiosResponse = function (
  currentData: any,
  statusCode: number
) {
  const data = currentData;
  const status = statusCode;
  return { data, status };
};

export interface ApiStandardListResponse {
  elements: Array<Element>;
}
